var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, makeObservable, computed } from 'mobx';
import { CustomFieldType } from './../custom-fields/models';
import { RecordingMode } from './models';
import { AppModeEnum } from '../models';
import { NO_ID, hasId, isNewId, newTempId } from '../common/ids';
var vehicleCaseTypeCodeFields = [
    {
        name: 'Field.Owner',
        value: '',
        width: 3,
        defaultLabel: 'Owner',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.Brand',
        value: '',
        width: 3,
        defaultLabel: 'Brand',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.Model',
        value: '',
        width: 3,
        defaultLabel: 'Model',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.Mileage',
        value: '',
        width: 1,
        defaultLabel: 'Mileage',
        type: CustomFieldType.Number
    },
    {
        name: 'Field.LicensePlateNumber',
        value: '',
        width: 2,
        defaultLabel: 'License plate number',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.CarSerialNumber',
        value: '',
        width: 3,
        defaultLabel: 'Car serial number',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.InsurancePolicyNumber',
        value: '',
        width: 3,
        defaultLabel: 'Insurance policy number',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.ExternalID',
        value: '',
        width: 3,
        defaultLabel: 'External ID',
        type: CustomFieldType.Text
    },
    {
        name: 'LineBreak',
        value: '',
        width: 12,
        defaultLabel: '',
        type: CustomFieldType.LineBreak
    },
    {
        name: 'ListField',
        value: 'Option 1',
        width: 3,
        defaultLabel: 'My list field',
        type: CustomFieldType.List,
        options: [
            { name: 'Option1', value: 'Option 1' },
            { name: 'Option2', value: 'Option 2' },
            { name: 'Option3', value: 'Option 3' }
        ]
    },
    {
        name: 'Field.Description',
        value: '',
        width: 3,
        defaultLabel: 'Description',
        type: CustomFieldType.LongText
    }
];
var propertyCaseTypeCodeFields = [
    {
        name: 'Field.Owner',
        value: '',
        width: 3,
        defaultLabel: 'Owner',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.Area',
        value: '',
        width: 3,
        defaultLabel: 'Area',
        type: CustomFieldType.Number
    },
    {
        name: 'Field.InsurancePolicyNumber',
        value: '',
        width: 3,
        defaultLabel: 'Insurance policy number',
        type: CustomFieldType.Text
    },
    {
        name: 'Field.ExternalID',
        value: '',
        width: 3,
        defaultLabel: 'External ID',
        type: CustomFieldType.Text
    },
    {
        name: 'RadioField',
        value: 'Option 1',
        width: 3,
        defaultLabel: 'My radio field',
        type: CustomFieldType.Radio,
        options: [
            { name: 'Option4', value: 'Option 4' },
            { name: 'Option5', value: 'Option 5' },
            { name: 'Option6', value: 'Option 6' }
        ]
    },
    {
        name: 'CheckboxField',
        value: '',
        width: 3,
        defaultLabel: 'My checkbox field',
        type: CustomFieldType.Checkbox,
        options: [
            { name: 'Option7', value: 'Option 7' },
            { name: 'Option8', value: 'Option 8' },
            { name: 'Option9', value: 'Option 9' }
        ]
    }
];
var caseTypeCodes = [
    {
        id: '1',
        name: 'Vehicle',
        fields: JSON.stringify(vehicleCaseTypeCodeFields),
        exportTemplate: ''
    },
    {
        id: '2',
        name: 'Property',
        fields: JSON.stringify(propertyCaseTypeCodeFields),
        exportTemplate: ''
    }
];
var defaultSmsOptions = {
    linkExpires: true,
    linkCanBeReused: true,
    linkExpirationMinutes: 1440,
    linkReuseMinutes: 0,
    smsTemplate: ''
};
var CaseTypesStore = /** @class */ (function () {
    function CaseTypesStore(rootStore, fieldsStore, addressBookStore) {
        var _this = this;
        var _a;
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: rootStore
        });
        Object.defineProperty(this, "fieldsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: fieldsStore
        });
        Object.defineProperty(this, "addressBookStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: addressBookStore
        });
        Object.defineProperty(this, "saveCaseTypeCodesCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "saveCaseTypesCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "cancelCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "onCurrentAddressChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "organizationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NO_ID
        });
        Object.defineProperty(this, "caseTypeCodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable(caseTypeCodes)
        });
        Object.defineProperty(this, "caseTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "viewableCaseTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "currentCaseTypeCodeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (_a = this.caseTypeCodes[0]) === null || _a === void 0 ? void 0 : _a.id
        });
        Object.defineProperty(this, "currentCaseTypeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.caseTypes.length > 0 ? this.caseTypes[0].id : ''
        });
        Object.defineProperty(this, "currentAddressId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NO_ID
        });
        Object.defineProperty(this, "isValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "caseDeleteMinDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 400
        });
        Object.defineProperty(this, "onSaveCaseTypeCodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a;
                var caseTypeCode = _this.caseTypeCodes.find(function (t) { return t.id === _this.currentCaseTypeCodeId; });
                if (!caseTypeCode)
                    return;
                caseTypeCode.fields = JSON.stringify((_a = _this.fieldsStore) === null || _a === void 0 ? void 0 : _a.fields);
                if (_this.saveCaseTypeCodesCallback)
                    _this.saveCaseTypeCodesCallback();
            }
        });
        Object.defineProperty(this, "onSaveCaseTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a;
                var currentCaseType = _this.caseTypes.find(function (t) { return t.id === _this.currentCaseTypeId; });
                if (!currentCaseType)
                    return false;
                var caseTypeCode = _this.caseTypeCodes.find(function (t) { return t.id === currentCaseType.caseTypeCodeID; });
                if (!caseTypeCode)
                    return false;
                if (currentCaseType.categories.length > 0 && currentCaseType.categories.find(function (c) { return !c.name; })) {
                    alert('Category name cannot be empty');
                    return false;
                }
                var updatedFields = JSON.stringify((_a = _this.fieldsStore) === null || _a === void 0 ? void 0 : _a.fields);
                if (caseTypeCode.fields !== updatedFields)
                    currentCaseType.fields = updatedFields;
                if (_this.saveCaseTypesCallback)
                    _this.saveCaseTypesCallback();
                return true;
            }
        });
        Object.defineProperty(this, "onCancel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                if (_this.cancelCallback)
                    _this.cancelCallback();
            }
        });
        makeObservable(this);
        window.$CaseTypesStore = this;
        this.refreshFields();
    }
    Object.defineProperty(CaseTypesStore.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (organizationId, caseTypeCodes, caseTypes, caseDeleteMinDays, saveCaseTypeCodesCallback, saveCaseTypesCallback, onCancel, onCurrentAddressChange) {
            var _this = this;
            if (!Array.isArray(caseTypes))
                return;
            this.organizationId = organizationId;
            this.caseDeleteMinDays = caseDeleteMinDays;
            this.caseTypeCodes.splice(0, this.caseTypeCodes.length);
            caseTypeCodes.forEach(function (c) { return _this.caseTypeCodes.push(c); });
            this.caseTypes.splice(0, this.caseTypes.length);
            if (caseTypes.length > 0) {
                caseTypes.forEach(function (t) {
                    if (t.description === null)
                        t.description = '';
                    _this.caseTypes.push(t);
                });
                this.setCurrentCaseType(this.caseTypes[0].id);
            }
            this.saveCaseTypeCodesCallback = saveCaseTypeCodesCallback;
            this.saveCaseTypesCallback = saveCaseTypesCallback;
            this.cancelCallback = onCancel;
            this.onCurrentAddressChange = onCurrentAddressChange;
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "currentCaseType", {
        get: function () {
            var _this = this;
            var currentCaseType = this.caseTypes.find(function (t) { return t.id === _this.currentCaseTypeId; });
            if (currentCaseType)
                return currentCaseType;
            // TODO: temporary solution to enable viewing of other organization's case types
            return this.viewableCaseTypes.find(function (t) { return t.id === _this.currentCaseTypeId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CaseTypesStore.prototype, "currentCaseTypeCode", {
        get: function () {
            var _this = this;
            var currentCaseTypeCode = this.caseTypeCodes.find(function (t) { return t.id === _this.currentCaseTypeCodeId; });
            return currentCaseTypeCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CaseTypesStore.prototype, "setCurrentCaseType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId, caseType) {
            var _this = this;
            var _a;
            this.currentCaseTypeId = caseTypeId;
            // TODO: temporary solution to enable viewing of other organization's case types
            if (caseType) {
                var existingCaseType = this.caseTypes.find(function (t) { return t.id === caseTypeId; });
                if (!existingCaseType) {
                    existingCaseType = this.viewableCaseTypes.find(function (t) { return t.id === caseTypeId; });
                    if (!existingCaseType)
                        this.viewableCaseTypes.push(caseType);
                }
            }
            if (this.currentAddressId) {
                var currentCaseType = this.currentCaseType;
                var index = (_a = currentCaseType === null || currentCaseType === void 0 ? void 0 : currentCaseType.addresses) === null || _a === void 0 ? void 0 : _a.findIndex(function (a) { return a.id === _this.currentAddressId; });
                if (index === undefined || index === -1)
                    this.currentAddressId = NO_ID;
            }
            this.refreshFields();
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "setCurrentAddress", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (addressItemId) {
            var _a;
            this.currentAddressId = addressItemId;
            if (!this.onCurrentAddressChange)
                return;
            if (hasId(addressItemId)) {
                var addresses = (_a = this.currentCaseType) === null || _a === void 0 ? void 0 : _a.addresses;
                if (addresses) {
                    var address = addresses.find(function (a) { return a.id === addressItemId; });
                    this.onCurrentAddressChange(address);
                }
            }
            else {
                this.onCurrentAddressChange(undefined);
            }
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "setCurrentCaseTypeCode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeCodeId) {
            this.currentCaseTypeCodeId = caseTypeCodeId;
            this.refreshFields();
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "updateCategoriesCaseType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (categories, caseTypeId) {
            var oldCaseType = this.caseTypes.find(function (t) { return t.id === caseTypeId; });
            if (!oldCaseType)
                return;
            oldCaseType.categories = categories;
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "addCaseType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeCodeId) {
            var caseTypeCode = this.caseTypeCodes.find(function (c) { return c.id === caseTypeCodeId; });
            if (!caseTypeCode)
                return;
            var newCaseTypeId = newTempId(this.caseTypes.map(function (t) { return t.id; }));
            this.caseTypes.push(__assign({ id: newCaseTypeId, name: caseTypeCode.name, description: '', exportTemplate: '', caseTypeCodeID: caseTypeCodeId, fields: '', isActive: true, organizationID: this.organizationId, enableDisclaimer: true, disclaimerText: '', emailTemplate: '', emailSenderLink: '', emailSubject: '', categories: [], isDataScrambleEnable: false, dataRetentionLevel1: 0, dataRetentionLevel2: 0, photoRetentionLevel1: 0, photoRetentionLevel2: 0, scrambledText: '', isOfflineAssessmentEnable: true, offlineAssessmentEmailBody: '', offlineAssessmentEmailSubject: '', allowOfflineModeExistingPhotoUpload: true, allowOfflineModeSendEmailToAgent: true, customCss: '', recordingMode: RecordingMode.None, autoStartRecording: false, enableSigning: false, signingText: '', printDateInPhotoBeforeUpload: false, printGpsInPhotoBeforeUpload: false, enableOfflineWorkflow: true, workflowSteps: [], enableInstantMessages: true }, defaultSmsOptions));
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "updateCaseType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseType) {
            var oldCaseType = this.caseTypes.find(function (t) { return t.id === caseType.id; });
            if (!oldCaseType)
                return;
            if (!caseType.name)
                return;
            oldCaseType.isActive = caseType.isActive;
            oldCaseType.caseTypeCodeID = caseType.caseTypeCodeID;
            oldCaseType.organizationID = caseType.organizationID;
            oldCaseType.name = caseType.name;
            oldCaseType.exportTemplate = caseType.exportTemplate;
            oldCaseType.description = caseType.description;
            oldCaseType.fields = caseType.fields;
            oldCaseType.linkExpires = caseType.linkExpires;
            oldCaseType.linkCanBeReused = caseType.linkCanBeReused;
            oldCaseType.smsTemplate = caseType.smsTemplate;
            oldCaseType.enableDisclaimer = caseType.enableDisclaimer;
            oldCaseType.disclaimerText = caseType.disclaimerText;
            oldCaseType.emailTemplate = caseType.emailTemplate;
            oldCaseType.emailSubject = caseType.emailSubject;
            oldCaseType.emailSenderLink = caseType.emailSenderLink;
            oldCaseType.categories = caseType.categories;
            oldCaseType.isDataScrambleEnable = caseType.isDataScrambleEnable;
            oldCaseType.dataRetentionLevel1 = caseType.dataRetentionLevel1;
            oldCaseType.dataRetentionLevel2 = caseType.dataRetentionLevel2;
            oldCaseType.photoRetentionLevel1 = caseType.photoRetentionLevel1;
            oldCaseType.photoRetentionLevel2 = caseType.photoRetentionLevel2;
            oldCaseType.scrambledText = caseType.scrambledText;
            oldCaseType.isOfflineAssessmentEnable = caseType.isOfflineAssessmentEnable;
            oldCaseType.offlineAssessmentEmailBody = caseType.offlineAssessmentEmailBody;
            oldCaseType.offlineAssessmentEmailSubject = caseType.offlineAssessmentEmailSubject;
            oldCaseType.allowOfflineModeExistingPhotoUpload = caseType.allowOfflineModeExistingPhotoUpload;
            oldCaseType.allowOfflineModeSendEmailToAgent = caseType.allowOfflineModeSendEmailToAgent;
            oldCaseType.recordingMode = caseType.recordingMode;
            oldCaseType.autoStartRecording = caseType.autoStartRecording;
            oldCaseType.enableSigning = caseType.enableSigning;
            oldCaseType.signingText = caseType.signingText;
            oldCaseType.printDateInPhotoBeforeUpload = caseType.printDateInPhotoBeforeUpload;
            oldCaseType.printGpsInPhotoBeforeUpload = caseType.printGpsInPhotoBeforeUpload;
            oldCaseType.customCss = caseType.customCss;
            var minExpirationValue = 0;
            var maxExpirationValue = 30 * 24 * 60;
            if (caseType.linkExpirationMinutes >= minExpirationValue && caseType.linkExpirationMinutes <= maxExpirationValue) {
                oldCaseType.linkExpirationMinutes = caseType.linkExpirationMinutes;
            }
            if (caseType.linkReuseMinutes >= minExpirationValue && caseType.linkReuseMinutes <= maxExpirationValue) {
                oldCaseType.linkReuseMinutes = caseType.linkReuseMinutes;
            }
            oldCaseType.enableOfflineWorkflow = caseType.enableOfflineWorkflow;
            oldCaseType.enableInstantMessages = caseType.enableInstantMessages;
            oldCaseType.workflowSteps = caseType.workflowSteps.map(function (s) { return __assign({}, s); });
            this.refreshFields();
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "removeCaseType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId) {
            var index = this.caseTypes.findIndex(function (t) { return t.id === caseTypeId; });
            if (index !== -1) {
                var caseType = this.caseTypes[index];
                if (isNewId(caseType.id))
                    this.caseTypes.splice(index, 1);
                else
                    caseType.isActive = false;
            }
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "activateCaseType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId) {
            var index = this.caseTypes.findIndex(function (t) { return t.id == caseTypeId; });
            if (index !== -1) {
                var caseType = this.caseTypes[index];
                caseType.isActive = true;
            }
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "addCaseTypeCode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var newCaseTypeCodeId = newTempId(this.caseTypeCodes.map(function (c) { return c.id; }));
            this.caseTypeCodes.push({
                id: newCaseTypeCodeId,
                name: 'New',
                fields: '',
                exportTemplate: ''
            });
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "updateCaseTypeCode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeCode) {
            var oldCaseTypeCode = this.caseTypeCodes.find(function (t) { return t.id === caseTypeCode.id; });
            if (!oldCaseTypeCode)
                return;
            if (!caseTypeCode.name)
                return;
            oldCaseTypeCode.name = caseTypeCode.name;
            oldCaseTypeCode.fields = caseTypeCode.fields;
            oldCaseTypeCode.exportTemplate = caseTypeCode.exportTemplate;
            this.refreshFields();
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "removeCaseTypeCode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeCodeId) {
            var index = this.caseTypeCodes.findIndex(function (t) { return t.id === caseTypeCodeId; });
            if (index !== -1) {
                this.caseTypeCodes.splice(index, 1);
                this.refreshFields();
            }
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "setValidField", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isValid) {
            this.isValid = isValid;
            this.refreshFields();
        }
    });
    Object.defineProperty(CaseTypesStore.prototype, "refreshFields", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var fields = '';
            if (this.rootStore.appMode === AppModeEnum.CaseTypeCodes && this.currentCaseTypeCodeId) {
                var caseTypeCode = this.caseTypeCodes.find(function (c) { return c.id === _this.currentCaseTypeCodeId; });
                if (caseTypeCode)
                    fields = caseTypeCode.fields;
            }
            else if ((this.rootStore.appMode === AppModeEnum.CaseTypes || this.rootStore.appMode === AppModeEnum.CustomFields) && this.currentCaseTypeId) {
                var caseType_1 = this.caseTypes.find(function (c) { return c.id === _this.currentCaseTypeId; });
                // TODO: temporary solution to enable viewing of other organization's case types
                if (!caseType_1)
                    caseType_1 = this.viewableCaseTypes.find(function (c) { return c.id === _this.currentCaseTypeId; });
                if (caseType_1) {
                    if (caseType_1.fields) {
                        fields = caseType_1.fields;
                    }
                    else {
                        var caseTypeCode = this.caseTypeCodes.find(function (c) { return c.id === (caseType_1 === null || caseType_1 === void 0 ? void 0 : caseType_1.caseTypeCodeID); });
                        if (caseTypeCode)
                            fields = caseTypeCode.fields;
                    }
                }
            }
            this.fieldsStore.fields = fields ? JSON.parse(fields) : [];
        }
    });
    __decorate([
        observable
    ], CaseTypesStore.prototype, "organizationId", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "caseTypeCodes", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "caseTypes", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "viewableCaseTypes", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "currentCaseTypeCodeId", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "currentCaseTypeId", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "currentAddressId", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "isValid", void 0);
    __decorate([
        observable
    ], CaseTypesStore.prototype, "caseDeleteMinDays", void 0);
    __decorate([
        action
    ], CaseTypesStore.prototype, "init", null);
    __decorate([
        computed
    ], CaseTypesStore.prototype, "currentCaseType", null);
    __decorate([
        computed
    ], CaseTypesStore.prototype, "currentCaseTypeCode", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "setCurrentCaseType", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "setCurrentAddress", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "setCurrentCaseTypeCode", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "updateCategoriesCaseType", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "addCaseType", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "updateCaseType", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "removeCaseType", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "activateCaseType", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "addCaseTypeCode", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "updateCaseTypeCode", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "removeCaseTypeCode", null);
    __decorate([
        action
    ], CaseTypesStore.prototype, "setValidField", null);
    return CaseTypesStore;
}());
export default CaseTypesStore;
